import type { Action } from 'src/types';

export enum Actions {
  NEXT_ROLE_UPDATE_LOCATIONS_START = 'NEXT_ROLE_UPDATE_LOCATIONS_START',
  NEXT_ROLE_UPDATE_LOCATIONS_SUCCESS = 'NEXT_ROLE_UPDATE_LOCATIONS_SUCCESS',
  NEXT_ROLE_UPDATE_LOCATIONS_FAILURE = 'NEXT_ROLE_UPDATE_LOCATIONS_FAILURE',

  NEXT_ROLE_UPDATE_WORKTYPE_START = 'NEXT_ROLE_UPDATE_WORKTYPE_START',
  NEXT_ROLE_UPDATE_WORKTYPE_SUCCESS = 'NEXT_ROLE_UPDATE_WORKTYPE_SUCCESS',
  NEXT_ROLE_UPDATE_WORKTYPE_FAILURE = 'NEXT_ROLE_UPDATE_WORKTYPE_FAILURE',

  NEXT_ROLE_UPDATE_AVAILABILITY_START = 'NEXT_ROLE_UPDATE_AVAILABILITY_START',
  NEXT_ROLE_UPDATE_AVAILABILITY_SUCCESS = 'NEXT_ROLE_UPDATE_AVAILABILITY_SUCCESS',
  NEXT_ROLE_UPDATE_AVAILABILITY_FAILURE = 'NEXT_ROLE_UPDATE_AVAILABILITY_FAILURE',

  NEXT_ROLE_UPDATE_RTW_START = 'NEXT_ROLE_UPDATE_RTW_START',
  NEXT_ROLE_UPDATE_RTW_SUCCESS = 'NEXT_ROLE_UPDATE_RTW_SUCCESS',
  NEXT_ROLE_UPDATE_RTW_FAILURE = 'NEXT_ROLE_UPDATE_RTW_FAILURE',

  NEXT_ROLE_UPDATE_SALARY_START = 'NEXT_ROLE_UPDATE_SALARY_START',
  NEXT_ROLE_UPDATE_SALARY_SUCCESS = 'NEXT_ROLE_UPDATE_SALARY_SUCCESS',
  NEXT_ROLE_UPDATE_SALARY_FAILURE = 'NEXT_ROLE_UPDATE_SALARY_FAILURE',

  NEXT_ROLE_UPDATE_CLASSIFICATION_START = 'NEXT_ROLE_UPDATE_CLASSIFICATION_START',
  NEXT_ROLE_UPDATE_CLASSIFICATION_SUCCESS = 'NEXT_ROLE_UPDATE_CLASSIFICATION_SUCCESS',
  NEXT_ROLE_UPDATE_CLASSIFICATION_FAILURE = 'NEXT_ROLE_UPDATE_CLASSIFICATION_FAILURE',

  NEXT_ROLE_UPDATE_APPROACHABILITY_START = 'NEXT_ROLE_UPDATE_APPROACHABILITY_START',
  NEXT_ROLE_UPDATE_APPROACHABILITY_SUCCESS = 'NEXT_ROLE_UPDATE_APPROACHABILITY_SUCCESS',
  NEXT_ROLE_UPDATE_APPROACHABILITY_FAILURE = 'NEXT_ROLE_UPDATE_APPROACHABILITY_FAILURE',
}

export type NextRoleAction =
  | Action<Actions.NEXT_ROLE_UPDATE_LOCATIONS_START>
  | Action<Actions.NEXT_ROLE_UPDATE_WORKTYPE_START>
  | Action<Actions.NEXT_ROLE_UPDATE_AVAILABILITY_START>
  | Action<Actions.NEXT_ROLE_UPDATE_RTW_START>
  | Action<Actions.NEXT_ROLE_UPDATE_SALARY_START>
  | (Action<Actions.NEXT_ROLE_UPDATE_APPROACHABILITY_START> & {
      payload: { approachable: boolean };
    })
  | (Action<Actions.NEXT_ROLE_UPDATE_APPROACHABILITY_FAILURE> & {
      payload: Error;
    })
  | Action<Actions.NEXT_ROLE_UPDATE_WORKTYPE_SUCCESS>
  | Action<Actions.NEXT_ROLE_UPDATE_APPROACHABILITY_SUCCESS>
  | (Action<Actions.NEXT_ROLE_UPDATE_WORKTYPE_FAILURE> & {
      payload: Error;
    })
  | Action<Actions.NEXT_ROLE_UPDATE_AVAILABILITY_SUCCESS>
  | (Action<Actions.NEXT_ROLE_UPDATE_AVAILABILITY_FAILURE> & {
      payload: Error;
    })
  | Action<Actions.NEXT_ROLE_UPDATE_RTW_SUCCESS>
  | Action<Actions.NEXT_ROLE_UPDATE_SALARY_SUCCESS>
  | (Action<Actions.NEXT_ROLE_UPDATE_RTW_FAILURE> & {
      payload: Error;
    })
  | (Action<Actions.NEXT_ROLE_UPDATE_SALARY_FAILURE> & { payload: Error })
  | Action<Actions.NEXT_ROLE_UPDATE_LOCATIONS_SUCCESS>
  | (Action<Actions.NEXT_ROLE_UPDATE_LOCATIONS_FAILURE> & {
      payload: Error;
    })
  | Action<Actions.NEXT_ROLE_UPDATE_CLASSIFICATION_START>
  | Action<Actions.NEXT_ROLE_UPDATE_CLASSIFICATION_SUCCESS>
  | (Action<Actions.NEXT_ROLE_UPDATE_CLASSIFICATION_FAILURE> & {
      payload: Error;
    });
